import React from 'react';
import {Clickable, Text} from 'bigdatr-style';
import {Flex} from 'bigdatr-style/layout';

export default function FilterHeading(props: {
    title: string;
    numberOfSelectedValues?: number;
    onClear?: () => void;
}) {
    const {numberOfSelectedValues, onClear, title} = props;
    const hasValuesSelected =
        typeof numberOfSelectedValues === 'number' && numberOfSelectedValues > 0;
    return (
        <Flex pb={2} justifyContent="space-between" alignItems="baseline">
            <Flex gap={2} alignItems="baseline">
                <Text textStyle="heading4">{title}</Text>
                {hasValuesSelected && (
                    <Text fontSize="0.75em"> {numberOfSelectedValues} selected</Text>
                )}
            </Flex>
            {onClear && hasValuesSelected && (
                <Clickable onClick={onClear}>
                    <Text textStyle="href">Clear</Text>
                </Clickable>
            )}
        </Flex>
    );
}
